import { useCallback, useRef } from "react";
import { useAttachmentDraggable } from "./useAttachmentDraggable.js";
import { useAttachmentDroppable } from "./useAttachmentDroppable.js";
import { useAppTreeControllerRef, useAppTreeTreeRef } from "../../../contexts/appTreeControllerContext.js";
function useDragDropBinding() {
    const controllerRef = useAppTreeControllerRef();
    const treeRef = useAppTreeTreeRef();
    const dragDropContainerRef = useRef(null);
    const makeDraggable = useAttachmentDraggable();
    const { refreshDroppable } = useAttachmentDroppable();
    const initDragDrop = useCallback(()=>{
        if (!controllerRef.current?.ref?.container) {
            return;
        }
        makeDraggable(true);
        makeDraggable();
        refreshDroppable();
    }, [
        controllerRef,
        makeDraggable,
        refreshDroppable
    ]);
    const bindTreeRef = useCallback((ref)=>{
        treeRef.current = ref;
        controllerRef.current.ref = ref;
        const container = ref?.container ?? null;
        if (container && dragDropContainerRef.current !== container) {
            dragDropContainerRef.current = container;
            initDragDrop();
        }
    }, [
        controllerRef,
        initDragDrop,
        treeRef
    ]);
    return {
        bindTreeRef,
        initDragDrop,
        refreshDroppable
    };
}
export { useDragDropBinding };
